export const ButtonToTop = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="ページトップへ"
  >
    <rect x="2" y="2" width="36" height="36" rx="18" fill="#222222" />
    <rect
      x="2"
      y="2"
      width="36"
      height="36"
      rx="18"
      stroke="white"
      strokeWidth="4"
    />
    <path
      d="M20 25.335V14.665"
      stroke="white"
      strokeWidth="1.52429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.665 20L20 14.665L25.335 20"
      stroke="white"
      strokeWidth="1.52429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
